import { Paging } from '@Core';
import { BaseHttpController } from '@Core/controller/BaseHttpController';
import { AxiosInstance } from 'axios';
import { CameraPhotos, CameraWithInfo, GeoZones } from '../../model';
import {
    IGetDetectionOverlapResponse,
    IGetCameraPhotosWithPlateObstructionProps,
    IGetCamerasWithPlateObstructionProps,
    IPotentialObstructionHttpController,
    IValidation,
} from '../IPotentialObstructionHttpController';

export class PotentialObstructionHttpController
    extends BaseHttpController<{}>
    implements IPotentialObstructionHttpController
{
    constructor(serviceUrl: string, client: AxiosInstance) {
        super(serviceUrl, 'potential-obstruction', client);
    }

    async getCameraPhotosWithPlateObstruction(
        props: IGetCameraPhotosWithPlateObstructionProps
    ): Promise<Paging<CameraPhotos>> {
        return await this.doPost({
            path: 'camera-photos-with-plate-obstruction',
            body: props,
        }).then((res) => res.data);
    }

    async getCameraWithCandidate(props: IGetCamerasWithPlateObstructionProps): Promise<Paging<CameraWithInfo>> {
        return await this.doPost({ path: 'get-camera-with-candidate', body: props }).then((res) => res.data);
    }

    async validation(props: IValidation): Promise<boolean> {
        return await this.doPost({ path: 'validation', body: props }).then((res) => res.data);
    }

    async getBoundingBoxByCameraPhotoId(props: { CameraPhotoId: number }): Promise<IGetDetectionOverlapResponse> {
        return await this.doPost({ path: 'get-bbox-by-camera-photo-id', body: props }).then((res) => res.data);
    }
}
